// extracted by mini-css-extract-plugin
module.exports = {"container":"_1R3SSu"};